module.exports = function () {
    $(document).ready(function () {
        let swal = require('sweetalert2');

        $(document).on('click', '.btn-archive', function (event) {
            event.preventDefault();
            let link = $(this);

            swal({
                title: "Are you sure you want to archive a document?",
                text: "",
                type: "warning",
                showCancelButton: true,
                showConfirmButton: true,
            }).then(result => {
                if (result.value) {
                    window.location = link.attr('href');
                }
            });
        })
    });
}();